import { nanoid } from 'nanoid';
import { Item } from '@teetsh/app/src/types/user';

// TODO invert naming serializeItems and deserializeItems
export const serializeItems = (items: string[]) =>
  (items || []).map(item => ({
    id: nanoid(5),
    value: item,
  }));

export const deserializeItems = (items: Item[]) =>
  (items || []).map(item => item.value);
